<script setup>
import { useTheme } from "vuetify";
import ScrollToTop from "@core/components/ScrollToTop.vue";
import initCore from "@core/initCore";
import { initConfigStore, useConfigStore } from "@core/stores/config";
import { hexToRgb } from "@core/utils/colorConverter";
import { initApiStore, useApiStore } from "./stores/api";
import echo from "./plugins/echo";

const { global } = useTheme();

// ℹ️ Sync current theme with initial loader theme
initCore();
initConfigStore();

initApiStore();

const configStore = useConfigStore();

const apiStore = useApiStore();
</script>

<template>
    <VLocaleProvider :rtl="configStore.isAppRTL">
        <!-- ℹ️ This is required to set the background color of active nav link based on currently active global theme's primary -->
        <VApp
            :style="`--v-global-theme-primary: ${hexToRgb(
                global.current.value.colors.primary,
            )}`"
        >
            <RouterView />
            <ScrollToTop />
        </VApp>
    </VLocaleProvider>
</template>
